import classNames from 'classnames';

export default {
    root: (customClassName?: string): string =>
        classNames({
            'carousel-root': true,
            [customClassName ?? '']: !!customClassName,
        }),

    carousel: (isSlider?: boolean): string =>
        classNames({
            carousel: true,
            'carousel-slider': isSlider,
        }),

    wrapper: (isSlider: boolean, axis?: 'horizontal' | 'vertical'): string =>
        classNames({
            'thumbs-wrapper m-20 overflow-hidden': !isSlider,
            'slider-wrapper': isSlider,
            'axis-horizontal': axis === 'horizontal',
            'axis-vertical': axis !== 'horizontal',
        }),

    slider: (isSlider: boolean, isSwiping?: boolean): string =>
        classNames({
            thumbs: !isSlider,
            'slider-wrap': isSlider,
            animated: !isSwiping,
        }),

    item: (isSlider: boolean, selected: boolean, previous?: boolean, position?: 'prev'|'next'): string =>
        classNames({
            thumb: !isSlider,
            slide: isSlider,
            selected: selected,
            previous: previous,
            slidePrev: position === 'prev',
            slideNext: position === 'next',
        }),

    arrow: (isHoverArrow: boolean | undefined): string =>
        classNames({
            normalArrow: !isHoverArrow,
            hoverArrow: isHoverArrow,
        }),

    arrowPrev: (disabled?: boolean): string =>
        classNames({
            'control-arrow control-prev': true,
            'control-disabled': disabled,
        }),

    arrowNext: (disabled?: boolean): string =>
        classNames({
            'control-arrow control-next': true,
            'control-disabled': disabled,
        }),

    dot: (selected?: boolean): string =>
        classNames({
            dot: true,
            selected: selected,
        }),
    dotAimation: (isPrevSelected: boolean): string =>
        classNames({
            NextSelected: isPrevSelected,
            PrevSelected: !isPrevSelected
        }),

    drag: (isswiping: boolean): string =>
        classNames({
            'move-drag': isswiping,
        }),
};
